import React, { useState } from 'react'
import { CRow, CSpinner, CButton } from '@coreui/react-pro'
import AppTextColumnDetails from 'src/components/details/general-details/AppTextColumnDetails'
import AppCard from 'src/components/AppCard'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'
import { getFullName } from 'src/helpers/text-format'

const MyProfile = () => {
  const { showSuccess, showError } = useToastMessage()
  const user = JSON.parse(localStorage.getItem('user')) || {}

  const canShowFullName = user?.profile
    && Object.prototype.hasOwnProperty.call(user?.profile, 'first_name')
    && Object.prototype.hasOwnProperty.call(user?.profile, 'last_name')

  const [loading, setLoading] = useState(false)

  const handleRequestResetPassword = () => {
    if (!user?.email) {
      showError('Email user not found')
      return
    }

    setLoading(true)
    Axios({
      method: 'post',
      url: '/api/tracker/v1/email/send/request-reset-password',
      data: {
        user: {
          id: user?.id,
          email: user?.email,
        },
      },
    })
      .then(() => {
        showSuccess(`Request reset password has been sent to ${user?.email}`)
      })
      .catch((err) => {
        console.error(err)
        const errMsg = err?.response?.data?.message || 'Failed to send reset password request'
        showError(errMsg)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <AppCard
      className='mb-4'
      headerTitle={<h4>My Profile</h4>}
      bodyContent={
        <div>
          <CRow className='mb-3'>
            <AppTextColumnDetails colSize="3" title='Email' subtitle={user?.email || '-'} />
            <AppTextColumnDetails colSize="3" title='Role' subtitle={user?.role_user || '-'} />
            {canShowFullName && <AppTextColumnDetails colSize="3" title='Full Name' subtitle={getFullName(user?.profile)} />}
          </CRow>

          <AppCard 
            headerTitle={<h4>Change your password</h4>}
            bodyContent={
              <div className='mb-3'>
                <CButton color="dark" onClick={handleRequestResetPassword} disabled={loading} className="mt-2">
                  {loading && (
                    <CSpinner
                      className='me-2'
                      component="span"
                      color="light"
                      size="sm"
                      aria-hidden="true"
                    />
                  )}
                  Change Password
                </CButton>
              </div>
            }
          />
        </div>
      }
    />
  )
}

export default MyProfile
